import React, { FCC } from 'react';

export const Badge: FCC<{}> = (props) => {
  return <span className={'badge'}>{props.children}</span>;
};

export default Badge;
